export const focusTrapMixin = {
  methods: {
    isFocusable(element) {
      // check if has tab index attr
      if (element.tabIndex > 0 || (element.tabIndex === 0 && element.getAttribute('tabIndex') !== null)) {
        return true;
      }
      // check if not disabled
      if (element.disabled) {
        return false;
      }
      // check types who not need to be focused
      switch (element.nodeName) {
        // link with bad href and not ignore rel
        case 'A':
          return Boolean(element.href) && element.rel != 'ignore';
        // hiden input and not file
        case 'INPUT':
          return element.type != 'hidden' && element.type != 'file';
        case 'BUTTON':
        case 'SELECT':
        case 'TEXTAREA':
          return true;
        default:
          return false;
      }
    },
    attemptFocus(element) {
      // if not focusable
      if (!this.isFocusable(element)) {
        return false;
      }

      //this.IgnoreUtilFocusChanges = true;
      try {
        element.focus();
      } catch (e) {
        console.warn(e);
      }
      //this.IgnoreUtilFocusChanges = false;
      return document.activeElement === element;
    },
    focusFirstDescendant(element) {
      // During "privacy" tests
      // If element.childNodes is undefined and have an error thrown
      // Ensure "privacy-cat-modal" has `ref="dialog"` defined
      for (let i = 0; i < element.childNodes.length; i++) {
        const child = element.childNodes[i];
        if (this.attemptFocus(child) || this.focusFirstDescendant(child)) {
          return true;
        }
      }
      return false;
    },
    focusLastDescendant(element) {
      for (let i = element.childNodes.length - 1; i >= 0; i--) {
        const child = element.childNodes[i];
        if (this.attemptFocus(child) || this.focusLastDescendant(child)) {
          return true;
        }
      }
      return false;
    },
  },
};
